import React, { useRef } from "react";
import Card from "./Card";

export default function SpecialList({ specialOffers, isRelated = false }) {
  const boxRef = useRef(null);

  const btnpressprev = () => {
    let width = boxRef.current.clientWidth;
    boxRef.current.scrollLeft = boxRef.current.scrollLeft - width;
  };

  const btnpressnext = () => {
    let width = boxRef.current.clientWidth;
    boxRef.current.scrollLeft = boxRef.current.scrollLeft + width;
  };

  return (
    <div style={{ position: "relative" }}>
      <i className="fa fa-angle-left pre-btn" onClick={btnpressprev} />
      <i className="fa fa-angle-right next-btn" onClick={btnpressnext} />

      <div className="product-carousel">
        <div className="special product-container" ref={boxRef}>
          {specialOffers &&
            specialOffers.map((x) => (
              <Card
                specialOffers={specialOffers}
                vehicle={x}
                key={x._id}
                special
                isRelated={isRelated}
              />
            ))}
        </div>
      </div>
    </div>
  );
}
